import * as React from "react";
import { Icon } from "sb-resp-ui";
import { EventIcon } from "../EventIcon";
export const FastMarketIcon = (props) => {
    const isEmpty = !props.hasFastMarket;
    const tooltip = !isEmpty ? props.tooltip : "";
    return (React.createElement(EventIcon, { isEmpty: isEmpty, hideOnMobile: false, tooltip: tooltip }, props.hasFastMarket &&
        React.createElement(Icon, { i: `i-24-16 i-o-ev-fast-market` })));
};
//# sourceMappingURL=FastMarketIcon.js.map